export abstract class TestUserData {
  static readonly LICENSE_PLATE = "SN710DE";
  static readonly EMAIL = "secka.dominik@gmail.com";
}

export abstract class TestCSOBData {
  static readonly CARD_NUMBER = "4125010001000208";
  static readonly EXPIRATION = "1234";
  static readonly CVC = "345";
}

export abstract class DataTestIds {
  static readonly LICENSE_PLATE_INPUT = "license-plate-input";
  static readonly LICENSE_PLATE_CONFIRMATION_INPUT = "license-plate-confirmation-input";
  static readonly EMAIL_INPUT = "email-input";
  static readonly EMAIL_CONFIRMATION_INPUT = "email-confirmation-input";
  static readonly EMAIL_NOTIFICATION_INPUT = "email-notification-input";
  static readonly VALID_SINCE_INPUT = "valid-since-input";
  static readonly VALID_SINCE_INPUT_TODAY_BUTTON = ".DayPicker-TodayButton";
  static readonly ECO_FUEL_TYPE_CHECK = "eco-fuel-type-check";
  static readonly ECO_FUEL_TYPE_NATURAL_GAS = "eco-fuel-type-natural-gas";
  static readonly ECO_FUEL_TYPE_BIO_METHANE = "eco-fuel-type-bio-methane";
  static readonly CARD_PAYMENT_TYPE_OPTION = "card-payment-type-option";
  static readonly GOOGLE_PAY_PAYMENT_TYPE_OPTION = "google-pay-payment-type-option";
  static readonly BANK_TRANSFER_PAYMENT_TYPE_OPTION = "bank-transfer-payment-type-option";
  static readonly COUNTRY_SELECT = "country-select";
  static readonly DISABLED_COUNTRY_SELECT = "disabled-country-select";
  static readonly TERMS_AND_CONDITIONS_CHECK = "terms-and-conditions-check";
  static readonly PROCEED_TO_PAYMENT_BUTTON = "proceed-to-payment-button";
  static readonly COMPANY_NAME_INPUT = "company-name-input";
  static readonly COMPANY_IDENTIFIER_INPUT = "company-identifier-input";

  static chargeCardPrice = (validFor: string) => `charge-card-${validFor}`;
}

export abstract class CSOBDataTestIds {
  static readonly CARD_NUMBER_INPUT = "#cardnumber";
  static readonly EXPIRY_INPUT = "#expiry";
  static readonly CVC_INPUT = "#cvc";
  static readonly PAY_SUBMIT_BUTTON = "#pay-submit";
}

export abstract class E2EAPIRoutes {
  static readonly ESHOP_ORDER = "http://localhost:3000/#/eshop/order";
  static readonly ESHOP_ORDER_HASH = "#/eshop/order";
  static readonly ESHOP_ORDER_STATUS = "http://localhost:3000/#/eshop/status";
  static readonly ESHOP_PAYMENT_DEV_INTERCEPT = "https://eshoppayment.dev.edalnice.cz/api/v1/**";
  static readonly IPLATEBNIBRANA_CSOB_CZ = "https://iplatebnibrana.csob.cz/pay/edalnice.cz";
}

export abstract class InterceptAliases {
  static readonly ESHOP_PAYMENT_DEV_INTERCEPT_ALIAS = "paymentRedirect";
}
